export default __webpack_public_path__ + "static/media/top-ten-block-1.0605822c.svg";